export default __webpack_public_path__ + "static/media/new-search.267f9f56.svg";